export const SHOW_ADD_PHONE_AFTER_LOGIN_KEY = "showAddPhoneAfterLogin";

/** If set in localStorage, the Crypto "confirm WhatsApp number" modal is not auto-shown again after the user dismissed it. */
export const PHONE_VERIFY_CHECK_DISMISSED_KEY = "phoneVerifyCheckDismissed";
